"use strict";

var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var getMarkerScale = (0, _utils.getValueScaler)({
  factorMax: 1,
  factorMin: 0.1,
  valueMax: 2,
  valueMin: 6
});
function renderDefaultMarker(graphState, entryProps, id) {
  var scale = getMarkerScale(graphState.zoomTransform.k);
  return /*#__PURE__*/React.createElement("marker", Object.assign({
    id: id,
    markerHeight: scale * 8,
    markerUnits: "userSpaceOnUse",
    markerWidth: scale * 8,
    orient: "auto",
    refX: scale * 8,
    refY: scale * 3
  }, entryProps), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,".concat(scale * 6, " L").concat(scale * 9, ",").concat(scale * 3, " z")
  }));
}
var SvgDefEntry = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SvgDefEntry, _React$PureComponent);
  var _super = _createSuper(SvgDefEntry);
  function SvgDefEntry() {
    _classCallCheck(this, SvgDefEntry);
    return _super.apply(this, arguments);
  }
  _createClass(SvgDefEntry, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        getClassName = _this$props.getClassName,
        localId = _this$props.localId,
        graphState = _this$props.graphState,
        _this$props$renderEnt = _this$props.renderEntry,
        renderEntry = _this$props$renderEnt === void 0 ? renderDefaultMarker : _this$props$renderEnt,
        setOnEntry = _this$props.setOnEntry;
      var id = graphState.renderUtils.getGlobalId(localId);
      var entryProps = (0, _utils.assignMergeCss)({
        className: getClassName('DefEntry')
      }, (0, _utils.getProps)(setOnEntry, graphState));
      return renderEntry(graphState, entryProps, id);
    }
  }]);
  return SvgDefEntry;
}(React.PureComponent);
exports.default = SvgDefEntry;